/* eslint-disable object-curly-newline */
import React from 'react';
import styled from '@emotion/styled';

import { PrimaryColor } from '../styles/colors';
import { mediaPhone, onlyTablet, minTablet, minDesktop } from '../styles/breakpoints';

import DownloadMaterialButton from '../DownloadMaterialButton';
import H2 from '../H2';
import Stacheldraht from '../Stacheldraht';

import Gallery from './Gallery';

import Image from './Grafik_Pfeil.png';
import Image2x from './Grafik_Pfeil@2x.png';

import IMAGES from './images.json';

const StacheldrahtInfoTop = styled(Stacheldraht)`
  margin-bottom: -30px;
  ${minTablet} {
    margin-bottom: -20px;
  }
`;

const StacheldrahtBottom = styled(Stacheldraht)`
  ${minTablet} {
    display: none;
  }
`;

const Info = styled.p`
  font-family: 'PT Mono', monospace;
  font-size: 16px; // 18px
  line-height: 1.2;
  text-align: center;
  color: ${PrimaryColor};
  transform: rotate(-3deg);
  margin-left: auto;
  margin-right: auto;
`;

const Section = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: 1020px;

  ${minTablet} {
    margin-bottom: 80px;
  }
`;

const DownloadAllContainer = styled.div`
  margin-top: 30px;
  text-align: center;
  margin-bottom: 30px;
`;

const DownloadAll = styled(DownloadMaterialButton)`
  padding: 15px;
  border-radius: 3px;
  text-align: center;
`;

const Title = styled(H2)`
  margin-bottom: 18px;
`;

const Pfeil = styled.img`
  position: relative;
  top: 0;
  left: 50%;
  ${mediaPhone} {
    top: -10px;
    left: 66%;
    width: 48px;
  }
`;

const InfoContainer = styled.div`
  position: relative;

  margin-left: auto;
  margin-right: auto;

  max-width: 330px;
  ${onlyTablet} {
    max-width: 540px;
  }
  ${minTablet} {
    font-size: 18px;
  }
  ${minDesktop} {
    max-width: 400px;
    left: -20%;
    top: -130px;
    margin-bottom: -130px;
  }
`;

/*
const makeUnsplashSrc = id => `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&w=1024&h=1024`;
const makeUnsplashSrcSet = (id, size) => `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&w=${size} ${size}w`;
const makeUnsplashThumbnail = (id, orientation = 'landscape') => {
  const dimensions = orientation === 'square' ? 'w=300&h=300' : 'w=240&h=159';
  return `https://images.unsplash.com/photo-${id}?dpr=2&auto=format&crop=faces&fit=crop&${dimensions}`;
};

// Unsplash images from the "Spirit Animals" collection
// https://unsplash.com/collections/158825/spirit-animals

const DEFAULT_IMAGES = [
  // { id: '1470619549108-b85c56fe5be8', caption: 'Photo by Alan Emery', orientation: 'square', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
  { id: '1449104532935-d9209c70e2b6', caption: 'Photo by Casey Allen', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
  { id: '1480472684115-4966367dde1d', caption: 'Photo by Gary Bendig', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/SYzUF6XcWBY (Flamingo)
  { id: '1454023492550-5696f8ff10e1', caption: 'Photo by Jessica Weiller', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/LmVSKeDy6EA (Tiger)
  { id: '1471079502516-250c19af6928', caption: 'Photo by Jeremy Bishop', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/GIpGxe2_cT4 (Turtle)
  { id: '1470854989922-5be2f7456d78', caption: 'Photo by Piotr Łaskawski', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/GXMr7BadXQo (Hedgehog)
  { id: '1470317596697-cbdeda56f999', caption: 'Photo by Michel Bosma', orientation: 'landscape', useForDemo: true }, // https://unsplash.com/photos/XgF9e93Tkt0 (Ladybug)
];
*/

const SmartboardGallery = () => (
  <Section>
    <InfoContainer>
      <StacheldrahtInfoTop small />
      <Info>
        Hier k&ouml;nnen Sie Bilder aus dem Unterrichtsmaterial zum Einsatz im Klassenraum herunterladen
      </Info>
      <Pfeil
        src={Image}
        srcSet={`${Image} 1x, ${Image2x} 2x`}
      />
    </InfoContainer>
    <Title>
      Smartboard-Galerie
    </Title>
    <Gallery images={IMAGES.map(({ caption, src, thumbnail, srcSet, orientation }) => ({
      src,
      thumbnail,
      srcSet,
      caption,
      orientation,
      useForDemo: true,
    }))}
    />
    <DownloadAllContainer>
      <DownloadAll
        label="Alle herunterladen"
        href="/downloads/Familien_und_Flucht_aus_der_DDR_Folien.zip"
        download="Familien und Flucht aus der DDR Folien.zip"
      />
    </DownloadAllContainer>
    <StacheldrahtBottom small />
  </Section>
);

/*
    <Gallery images={DEFAULT_IMAGES.map(({ caption, id, orientation, useForDemo }) => ({
      src: makeUnsplashSrc(id),
      thumbnail: makeUnsplashThumbnail(id, orientation),
      srcSet: [
        makeUnsplashSrcSet(id, 1024),
        makeUnsplashSrcSet(id, 800),
        makeUnsplashSrcSet(id, 500),
        makeUnsplashSrcSet(id, 320),
      ],
      caption,
      orientation,
      useForDemo,
    }))}
    />
*/

export default SmartboardGallery;



// WEBPACK FOOTER //
// ./src/components/SmartboardGallery/SmartboardGallery.js